import React, { FC, useEffect, useState } from 'react'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import s from './Feedback.module.scss'
import { Link } from 'react-router-dom'

const animation = {
    hidden: { opacity: 0, y: 200 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5
        }
    }
}

const Feedback: FC = () => {
    const controls = useAnimation()
    const { ref, inView } = useInView({ threshold: 0.1 })
    const [hasAnimated, setHasAnimated] = useState(false)

    useEffect(() => {
        if (inView && !hasAnimated) {
            controls.start('visible')
            setHasAnimated(true)
        }
    }, [controls, inView, hasAnimated])

    return (
        <section className={s.section}>
            <span className={`${s.lineGradient} lineGradient top-line`} />
            <motion.div
                className={`${s.wrapper} container`}
                initial="hidden"
                animate={controls}
                variants={animation}
                ref={ref}
            >
                <div className={s.content}>
                    <h2 className={`${s.title} title`}>Обсудим Ваш проект?</h2>
                    <Link to="/contacts" className={s.contactButton}>
                    Связаться с нами
                    </Link>
                </div>
            </motion.div>
        </section>
    )
}

export default Feedback
